// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore, collection, getDocs } from "firebase/firestore/lite";

const firebaseConfig = {
  apiKey: "AIzaSyDoSCdNB2l6xqeFcTkVAWDlLuWbYhIsWeM",
  authDomain: "book-app-f4805.firebaseapp.com",
  projectId: "book-app-f4805",
  storageBucket: "book-app-f4805.appspot.com",
  messagingSenderId: "826742538496",
  appId: "1:826742538496:web:62701ae21c97e0989073e5",
  measurementId: "G-MZ32T0V8XT",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const db = getFirestore(app);
